import assert from 'assert';

import {LibraryParameterDefinitionDataType} from 'procedures/parameter-library/ParameterLibraryTypes';
import {
  DataParameterFieldType,
  SUPPORTED_DATA_PARAMETER_FIELD_TYPES,
} from 'procedures/shared-components/schema-field-type-selectors/procedureSchemaFieldConstants';
import {fieldDefinitionTypeToFieldType} from 'schemas/fields/FieldDefinitionCompatibilityUtils';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

function isDataParameterFieldType(fieldType: FieldType): fieldType is DataParameterFieldType {
  return (SUPPORTED_DATA_PARAMETER_FIELD_TYPES as ReadonlyArray<FieldType>).includes(fieldType);
}

/**
 * Maps library definition `dataType` from GraphQL to the procedure {@link DataParameterFieldType}
 * used in {@link DataParameterType} and type-column typed values.
 */
export function libraryDefinitionDataTypeToDataParameterFieldType(
  dataType: LibraryParameterDefinitionDataType
): DataParameterFieldType {
  const fieldType = fieldDefinitionTypeToFieldType(dataType);
  assert(
    isDataParameterFieldType(fieldType),
    `Unexpected field type for library parameter data type: ${dataType}`
  );
  return fieldType;
}
